import { hashString } from './sha-hash';

export async function pushEmailAnalytics({ formName, model, sendName, personalDetails }) {
    if (!formName) {
        return;
    }

    if (!personalDetails) {
        personalDetails = await HONDA.MyAccount2.client.getPersonalDetails();
    }

    const data = {
        event: formName,
        form_name: formName,
        ec_data: {
            email: await hashString(personalDetails?.email),
        },
    };

    if (model) {
        data.model = model;
    }

    if (sendName) {
        data.ec_data.first_name = await hashString(personalDetails.firstName);
        data.ec_data.last_name = await hashString(personalDetails.lastName);
    }

    window.dataLayer.push(data);
}
